import { BaseHttpService, CmsApi, ConfiguratorApi, createNetworkAwareService, PlatformApi } from "@pandas/http-client";
import { servicesOrchestratorValues } from "@/config/services";
import logger from "@/lib/logging/logger";

const { urls } = servicesOrchestratorValues;

export type WebappApiClient = {
	platform: PlatformApi;
	configurator: ConfiguratorApi;
	cms: CmsApi;
};

export function createWebappApiClient(): WebappApiClient {
	function makeHttp(baseUrl: string) {
		return createNetworkAwareService(new BaseHttpService(baseUrl, logger));
	}

	const platform = new PlatformApi(makeHttp(`${urls.platform}/api/v1`));
	const configurator = new ConfiguratorApi(makeHttp(`${urls.platform}/api/v2`), "webapp");
	const cms = new CmsApi(makeHttp(urls.cms));

	return { platform, configurator, cms };
}
